export const INITIALIZE = '[Register] Initialize';
export const CHECK_EXISTING_EMAIL = '[Register] Check existing email';
export const CHECK_EXISTING_EMAIL_DONE = '[Register] Check existing email done';
export const DESTROY = '[Register] Destroy';
export const SET_ERROR_MESSAGE = '[Register] Set Error Message';
export const GET_VERIFICATION_CODE = '[Register] Get verification code';
export const SET_VERIFICATION_DETAILS = '[Register] Set verification details';
export const SET_USER_DETAILS = '[Register] Set user details';
export const SET_ORGANISATION_DETAILS = '[Register] Set organisation details';
export const CONFIRM_VERIFICATION_CODE = '[Register] Confirm verification code';
export const REGISTER_USER = '[Register] Register user';
export const CHECK_EXISTING_DOMAIN = '[Register] Check existing domain';
export const CHECK_EXISTING_DOMAIN_DONE = '[Register] Check existing domain done';
export const REGISTER_ORGANISATION = '[Register] Register organisation';
export const REGISTER_ORGANISATION_DONE = '[Register] Register organisation done';